<button
  [ngClass]="btnCss"
  [attr.data-e2e]="e2eId"
  [class.btn--loading]="loader"
  [disabled]="disabled"
  (click)="btnClick.emit($event)"
  *ngIf="text"
>
  <nibtravel-icon
    *ngIf="icon"
    [icon]="icon"
    [size]="iconSize"
    spacing="space-sides"
  ></nibtravel-icon>
  {{ text }}
</button>
